import React, { useState, useEffect, useRef } from "react";
import { Form } from 'react-bootstrap';
import "./Account.css";
import "../../assets/css/modal.css";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { getCustomerProfile, updateCustomerProfile } from "../../actions/authActions";
import UpdateProfile from "../../components/Modals/UpdateProfile";
import { set, useForm } from "react-hook-form";
import ChangePassword from "../../components/Modals/ChangePassword";
import { FiUser, FiMail, FiPhone, FiLock, FiSave, FiCamera, FiChevronDown, FiCalendar } from "react-icons/fi";
import { FaUser } from "react-icons/fa";

const PHOTO_TYPES = ["image/jpeg", "image/png", "image/gif"];
const PHOTO_MAX_BYTES = 5 * 1024 * 1024;

const Account = (props) => {
  const [updatedFirstName, setUpdatedFirstName] = useState("");
  const [updatedLastName, setUpdatedLastName] = useState("");
  const [updatedEmail, setUpdatedEmail] = useState("");
  const [updatedPhone, setUpdatedPhone] = useState("");
  const [phoneCode, setPhoneCode] = useState('+65');
  const [phoneCodeVal, setPhoneCodeVal] = useState("SG")
  const phoneCodeElement = useRef(null)
  const [phoneNumber, setPhoneNumber] = useState('');
  const [fname, setFname] = useState(null);
  const [lname, setlName] = useState(null);
  const [emaill, setEmail] = useState(null);
  const [phone, setPhone] = useState(null);

  const [fnameStatus, setFnameStatus] = useState("");
  const [lnameStatus, setlnameStatus] = useState("");
  const [phoneNoStatus, setPhoneNoStatus] = useState("ERROR");

  const [load, setLoad] = useState(false);
  const [show, setShow] = useState(false);
  const [popupTxt, setPopupTxt] = useState("")
  const [lshow, setLshow] = useState(false);
  const [hover, setHover] = useState(false);

  const [updatedDob, setUpdatedDob] = useState("");
  const dobEdited = useRef(false);

  const photoInput = useRef(null);
  const [photoFile, setPhotoFile] = useState(null);
  const [photoPreview, setPhotoPreview] = useState("");
  const [photoError, setPhotoError] = useState("");
  // URL of a just-uploaded photo, until the refetched profile reports it.
  const pendingPhotoUrl = useRef(null);

  // Release the preview object URL when it changes or the page unmounts
  useEffect(() => {
    return () => {
      if (photoPreview) URL.revokeObjectURL(photoPreview);
    };
  }, [photoPreview]);

  function handlePhotoChange(event) {
    const file = event.target.files && event.target.files[0];
    event.target.value = ""; // allow re-selecting the same file
    if (!file) return;

    if (!PHOTO_TYPES.includes(file.type)) {
      setPhotoError("Please choose a JPG, PNG or GIF image.");
      return;
    }
    if (file.size > PHOTO_MAX_BYTES) {
      setPhotoError("Image must be 5MB or smaller.");
      return;
    }

    setPhotoError("");
    pendingPhotoUrl.current = null; // a newer pick replaces any upload still settling
    setPhotoFile(file);
    setPhotoPreview(URL.createObjectURL(file));
  }

  const countries = [{
    'name': 'SG',
    'code': '+65'
  }]


  const { register, handleSubmit } = useForm();
  const [canSubmit, setSubmitState] = useState(false);

  const getLoginData = () => {
    try {
      if (localStorage.headers) {
        return JSON.parse(window.localStorage.getItem('headers'));
      }
    } catch (e) {
      return null;
    }
    return null;
  };

  const login = getLoginData();
  const userid = login?.data?.user?.user_id;

  // Last update response already shown. Seeded with whatever is in the store on mount
  // so a response from an earlier visit doesn't pop up again.
  const handledUpdate = useRef(props.update_customer_profile);
  // Stored session the form was last filled from.
  const syncedSession = useRef(null);

  useEffect(() => {
    if (!load) {
      props.getCustomerProfile();
      setLoad(true);
    }

    const update = props.update_customer_profile;
    if (update && update !== handledUpdate.current) {
      handledUpdate.current = update;
      if (update.message === 'Update user profile successful.') {
        // Re-read the session so fields written since this render (e.g. the photo URL) survive
        const current = getLoginData();
        if (current?.data?.user) {
          current.data.user.fname = updatedFirstName;
          current.data.user.lname = updatedLastName;
          current.data.user.dob = updatedDob || null;
          localStorage.setItem('headers', JSON.stringify(current));
          window.dispatchEvent(new Event('profileUpdated')); // refresh the header name
        }
        if (photoFile && update.profile_image_url) {
          pendingPhotoUrl.current = update.profile_image_url;
        }
        setPhotoFile(null); // uploaded; don't resend on the next save
        props.getCustomerProfile(); // pick up the saved profile_image_url
        setPopupTxt("User profile updated successfully.");
        setLshow(true);
      } else {
        console.log(update.message);
        setPopupTxt("Update failed. Please try again.");
        setLshow(true);
      }
    }

    // Refill the form only when the stored user details change (first load, login, after a
    // save) so background refreshes, like the photo URL, don't wipe unsaved edits.
    const sessionUser = getLoginData()?.data?.user;
    const session = JSON.stringify([sessionUser?.user_id, sessionUser?.fname, sessionUser?.lname, sessionUser?.contactNo, sessionUser?.email]);
    if (session !== syncedSession.current) {
      syncedSession.current = session;
      setUpdatedFirstName(sessionUser?.fname === "NA" ? "" : sessionUser?.fname);
      setUpdatedLastName(sessionUser?.lname);
      setUpdatedPhone(sessionUser?.contactNo);
      setEmail(sessionUser?.email);
    }
  }, [props, load]);

  // Refetch the profile when the tab regains focus so a photo changed elsewhere shows up.
  useEffect(() => {
    const refresh = () => {
      if (localStorage.headers) props.getCustomerProfile();
    };
    window.addEventListener('focus', refresh);
    return () => window.removeEventListener('focus', refresh);
  }, []);

  useEffect(() => {
    const nameRegex = /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/;
    const phoneNoRegex = /^\+65(6|8|9)\d{7}$/;
    // setSubmitState(false);
    {/*  if (updatedFirstName == "") {
      setFnameStatus("");
    } else {
      if (nameRegex.test(updatedFirstName)) {
        setFnameStatus(<div className="footer-warley-description text-success">Valid Name</div>)
      } else {
        setFnameStatus(<div className="footer-warley-description text-danger">Invalid Name</div>)
      }
    }

    if (updatedLastName == "") {
      setlnameStatus("");
    } else {
      if (nameRegex.test(updatedLastName)) {
        setlnameStatus(<div className="footer-warley-description text-success">Valid Name</div>)
      } else {
        setlnameStatus(<div className="footer-warley-description text-danger">Invalid Name</div>)
      }
    } */}

    const getError = (value, regex, errorMsg) =>
      value === "" || regex.test(value)
        ? ""
        : <div className="footer-warley-description text-danger">{errorMsg}</div>;

    setFnameStatus(getError(updatedFirstName, nameRegex, "Invalid Name"));
    setlnameStatus(getError(updatedLastName, nameRegex, "Invalid Name"));
    setPhoneNoStatus(getError(updatedPhone, phoneNoRegex, "Invalid Phone Number"));

    setSubmitState(
      nameRegex.test(updatedFirstName) &&
      nameRegex.test(updatedLastName) &&
      phoneNoRegex.test(updatedPhone)
    );

    // if (updatedPhone == "") {
    //   setPhoneNoStatus("");
    // } else {
    //   if (phoneNoRegex.test(updatedPhone)) {
    //     setPhoneNoStatus(<div className="footer-warley-description text-success">Valid Phone Number</div>)
    //   } else {
    //     setPhoneNoStatus(<div className="footer-warley-description text-danger">Invalid Phone Number</div>)
    //   }
    // }

    // if (nameRegex.test(updatedFirstName) && nameRegex.test(updatedLastName) && phoneNoRegex.test(updatedPhone)) {
    //   setSubmitState(true);
    // }

    setSubmitState(
      nameRegex.test(updatedFirstName) &&
      nameRegex.test(updatedLastName) &&
      phoneNoRegex.test(updatedPhone)
    );
  }, [updatedFirstName, updatedLastName, updatedPhone]);


  function updateFirstName(event) {
    const value = event.target.value;
    setUpdatedFirstName(value);

    const nameRegex = /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/;

    if (value === "") {
      setFnameStatus(""); // hide message if empty
    } else if (nameRegex.test(value)) {
      setFnameStatus(
        <div className="footer-warley-description text-success">
          Valid Name
        </div>
      );
    } else {
      setFnameStatus(
        <div className="footer-warley-description text-danger">
          Invalid Name
        </div>
      );
    }
  }

  function updateLastName(event) {
    const value = event.target.value;
    setUpdatedLastName(value);

    const nameRegex = /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/;

    if (value === "") {
      setlnameStatus(""); // hide message if empty
    } else if (nameRegex.test(value)) {
      setlnameStatus(
        <div className="footer-warley-description text-success">
          Valid Name
        </div>
      );
    } else {
      setlnameStatus(
        <div className="footer-warley-description text-danger">
          Invalid Name
        </div>
      );
    }
  }



  function updateEmail(event) {
    if (updatedEmail === null) {
      setUpdatedEmail(emaill)
    } else { setUpdatedEmail(event.target.value) }
    console.log(updatedEmail)
  }

  function updatePhoneCode(event) {
    var newPhoneCode = event.target.value;
    setPhoneCodeVal(event.target.name)
    setPhoneNumber(phoneNumber.replace(phoneCode, newPhoneCode));
    setPhoneCode(newPhoneCode);
  }

  function updatePhone(event) {
    if (updatedPhone === null) {
      setUpdatedPhone(phone)
      console.log(phone)
    } else { setUpdatedPhone(event.target.value) }
  }

  //Validating the submit state
  if (document.querySelector("#updateButton")) { //Check if not null
    if (canSubmit === false) {
      document.querySelector("#updateButton").style.opacity = 0.5
      document.querySelector("#updateButton").disabled = true
    } else {
      document.querySelector("#updateButton").style.opacity = 1.0
      document.querySelector("#updateButton").disabled = false
    }
  }

  const onSubmit = () => {
    // Multipart so the photo can go with the profile fields.
    // FormData stringifies null/undefined, so send "" instead (Laravel reads it as null).
    const data = new FormData();
    data.append("id", userid ?? "");
    data.append("first_name", updatedFirstName ?? "");
    data.append("last_name", updatedLastName ?? "");
    data.append("phone", updatedPhone ?? "");
    data.append("dob", updatedDob ?? "");
    if (photoFile) {
      data.append("profile_image", photoFile);
    }
    props.updateCustomerProfile(data);
  }

  // Photo comes from /auth/customer_profile; ignore a profile left over from another user.
  const profile = props.customer_profile;
  const savedPhotoUrl =
    profile && userid != null && String(profile.id) === String(userid)
      ? profile.profile_image_url
      : "";
  const avatarSrc = photoPreview || savedPhotoUrl;

  // DOB comes as YYYY-MM-DD (profile API, else the stored session), which is what a date input takes.
  const rawDob =
    (profile && userid != null && String(profile.id) === String(userid) ? profile.dob : null) ||
    login?.data?.user?.dob ||
    "";
  const savedDob = (/^\d{4}-\d{2}-\d{2}/.exec(rawDob) || [""])[0];

  // Fill from the saved value until the user edits, so background refreshes don't wipe their pick.
  useEffect(() => {
    if (!dobEdited.current) setUpdatedDob(savedDob);
  }, [savedDob]);

  // Once the refetched profile carries the uploaded photo, swap the local preview for it.
  // Preload first so the avatar doesn't blank out while the new URL downloads.
  // Runs on every profile fetch, as the URL may be unchanged.
  useEffect(() => {
    const target = pendingPhotoUrl.current;
    if (!target || savedPhotoUrl !== target) return;
    let cancelled = false;
    const img = new Image();
    img.onload = () => {
      if (cancelled || pendingPhotoUrl.current !== target) return;
      pendingPhotoUrl.current = null;
      setPhotoPreview("");
    };
    img.src = target;
    return () => { cancelled = true; };
  }, [profile]);

  // Cache the API's photo URL in the stored session and tell the header to show it.
  useEffect(() => {
    if (!profile || userid == null || String(profile.id) !== String(userid)) return;
    const session = getLoginData();
    const sessionUser = session?.data?.user;
    const url = profile.profile_image_url || null;
    if (!sessionUser || sessionUser.profile_image_url === url) return;
    sessionUser.profile_image_url = url;
    localStorage.setItem('headers', JSON.stringify(session));
    window.dispatchEvent(new Event('profileUpdated'));
  }, [profile]);

  const showModal = (event, val) => {
    event && event.preventDefault();
    setShow(val);
  };

  return (
    <>
      <UpdateProfile
        text={popupTxt}
        show={lshow}
        closeModal={() => setLshow(false)}
      />
      <ChangePassword
        show={show === 1 ? true : false}
        closeModal={() => setShow(null)}
      />

      <div className="acc-page-wrapper">
        <div className="acc-card">
          <form onSubmit={handleSubmit(onSubmit)}>

            <h2 className="acc-title">User Information</h2>

            <div className="acc-body">

              {/* Profile Photo */}
              <div className="acc-photo">
                <button
                  type="button"
                  className="acc-avatar"
                  onClick={() => photoInput.current && photoInput.current.click()}
                  aria-label="Upload profile photo"
                >
                  <span className="acc-avatar-inner">
                    {avatarSrc ? (
                      <img src={avatarSrc} alt="Profile" className="acc-avatar-img" />
                    ) : (
                      <FaUser className="acc-avatar-placeholder" />
                    )}
                  </span>
                  <span className="acc-avatar-badge" aria-hidden="true">
                    <FiCamera />
                  </span>
                </button>
                <input
                  ref={photoInput}
                  type="file"
                  accept={PHOTO_TYPES.join(",")}
                  onChange={handlePhotoChange}
                  className="d-none"
                />
                <div className="acc-photo-title">
                  {avatarSrc ? "Change Profile Photo" : "Upload Profile Photo"}
                </div>
                <div className="acc-photo-hint">JPG, PNG or GIF • Max 5MB</div>
                {photoError && (
                  <div className="acc-photo-error" role="alert">{photoError}</div>
                )}
              </div>

              <div className="acc-grid">

                {/* First Name */}
                <div className="acc-field-group">
                  <label className="acc-label">
                    First Name <span className="acc-required">*</span>
                  </label>
                  <div className="acc-input-wrap">
                    <FiUser className="acc-input-icon" />
                    <input
                      type="text"
                      autoComplete="off"
                      onChange={updateFirstName}
                      value={updatedFirstName}
                      placeholder="Enter first name"
                      className="acc-input"
                      required
                      aria-required="true"
                    />
                  </div>
                  <div className="acc-feedback">{fnameStatus}</div>
                </div>

                {/* Last Name */}
                <div className="acc-field-group">
                  <label className="acc-label">
                    Last Name <span className="acc-required">*</span>
                  </label>
                  <div className="acc-input-wrap">
                    <FiUser className="acc-input-icon" />
                    <input
                      type="text"
                      autoComplete="off"
                      onChange={updateLastName}
                      value={updatedLastName}
                      placeholder="Enter last name"
                      className="acc-input"
                      required
                      aria-required="true"
                    />
                  </div>
                  <div className="acc-feedback">{lnameStatus}</div>
                </div>

                {/* Phone Number */}
                <div className="acc-field-group">
                  <label className="acc-label">Phone Number</label>
                  <div className="acc-input-wrap acc-phone-wrap">
                    <FiPhone className="acc-input-icon" />
                    <Form.Control
                      as="select"
                      {...register("ccode")}
                      onChange={updatePhoneCode}
                      className="acc-phone-select"
                    >
                      {countries.map(({ name, phoneCode }) => (
                        <option key={name} value={phoneCode} name={name}>{name}</option>
                      ))}
                    </Form.Control>
                    <FiChevronDown className="acc-phone-chevron" />
                    <input
                      autoComplete="off"
                      {...register("phone")}
                      placeholder="Phone number"
                      minLength="8"
                      onChange={updatePhone}
                      value={updatedPhone}
                      required
                      disabled
                      className="acc-input acc-phone-number"
                      style={{ cursor: "not-allowed" }}
                    />
                  </div>
                  <div className="acc-feedback">{phoneNoStatus}</div>
                </div>

                {/* Date of Birth */}
                <div className="acc-field-group">
                  <label className="acc-label">Date of Birth</label>
                  <div className="acc-input-wrap">
                    <FiCalendar className="acc-input-icon" />
                    <input
                      type="date"
                      value={updatedDob}
                      onChange={(e) => {
                        dobEdited.current = true;
                        setUpdatedDob(e.target.value);
                      }}
                      max={new Date().toISOString().slice(0, 10)}
                      className="acc-input"
                    />
                  </div>
                </div>

                {/* Email Address */}
                <div className="acc-field-group">
                  <label className="acc-label">Email Address</label>
                  <div className="acc-input-wrap">
                    <FiMail className="acc-input-icon" />
                    <input
                      type="email"
                      autoComplete="off"
                      onChange={updateEmail}
                      value={updatedEmail}
                      placeholder={emaill}
                      disabled
                      className="acc-input"
                      style={{ cursor: "not-allowed" }}
                    />
                  </div>
                </div>

              </div>
            </div>

            {/* Action Buttons */}
            <div className="acc-actions">
              <button
                type="button"
                className="acc-btn-outline"
                onClick={(event) => showModal(event, 1)}
              >
                <FiLock size={15} style={{ marginRight: 7 }} />
                Change Password
              </button>
              <button
                id="updateButton"
                type="submit"
                className="acc-btn-primary"
                disabled={!canSubmit}
              >
                <FiSave size={15} style={{ marginRight: 7 }} />
                Save Changes
              </button>
            </div>

          </form>
        </div>
      </div>
    </>
  );
};

Account.propTypes = {
  // closeModal: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  loading: state.auth.loading,
  customer_profile: state.auth.customer_profile,
  update_customer_profile: state.auth.update_customer_profile,
  errors: state.auth.errors
});
export default withTranslation()(
  connect(mapStateToProps, { getCustomerProfile, updateCustomerProfile })(Account)
);
